import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import '../styles/PaymentResult.css';

const Error = () => {
  const [searchParams] = useSearchParams();
  const [paymentId, setPaymentId] = useState('');

  useEffect(() => {
    const id = searchParams.get('id') || '';
    setPaymentId(id);
  }, [searchParams]);

  const handleWhatsAppClick = () => {
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '5491112345678';
    const message = paymentId 
      ? `Hola, tuve un problema con mi compra #${paymentId}`
      : 'Hola, tuve un problema con mi compra';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="payment-result-container">
      <div className="payment-result-content">
        <div className="payment-result-icon error-icon">
          ❌
        </div>
        <h1 className="payment-result-title">Pago No Procesado</h1>
        <p className="payment-result-message">
          Lo sentimos, hubo un problema al procesar tu pago.
          {paymentId && (
            <span className="payment-id"> Tu código de compra es: <strong>#{paymentId}</strong></span>
          )}
        </p>
        <p className="payment-result-submessage">
          Por favor, intenta nuevamente o contáctanos por WhatsApp para recibir ayuda.
        </p>
        
        <div className="payment-result-actions">
          <button 
            className="btn btn-whatsapp btn-large payment-whatsapp-btn"
            onClick={handleWhatsAppClick}
          >
            <span>💬</span>
            Contactar por WhatsApp
          </button>
          
          <Link to="/" className="btn btn-secondary payment-home-btn">
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error;


